<div mat-dialog-title class="flex! items-center">
    <span class="flex-auto">Error details</span>
    <button mat-icon-button (click)="onCloseDialogButtonClick()"><mat-icon>close</mat-icon></button>
</div>
<mat-divider style="margin-bottom: 16px" />

<div mat-dialog-content style="padding: 0px 1rem">
    <p>Er is een fout opgetreden</p>
    @if (debugModeIsActive()) {
        <p style="white-space: pre-wrap; line-break: anywhere">{{ errorReason() }}</p>
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-stroked-button cdkFocusInitial (click)="onCloseDialogActionButtonClick()">Sluiten</button>
</div>
